const SignupConfigData = ({ email } = {}) => ({
  email: email || "",
  password: "",
  password_confirmation: ""
});

export default SignupConfigData;
